import { createAshe, castAsheW, castAsheR } from './champions/ashe.js';
import { createGaren, castGarenQ, castGarenE, castGarenR } from './champions/garen.js';
import { createRyze, castRyzeQ, castRyzeW } from './champions/ryze.js';
import { createAnnie, castAnnieQ, castAnnieW, castAnnieR } from './champions/annie.js';
import { createSivir, castSivirQ, castSivirE, castSivirR } from './champions/sivir.js';
import { createDarius, castDariusQ, castDariusW, castDariusE, castDariusR } from './champions/darius.js';
import { createSett, castSettQ, castSettW, castSettE, castSettR } from './champions/sett.js';
import { createJax, castJaxQ, castJaxW, castJaxE, castJaxR } from './champions/jax.js';
import { createLux, castLuxQ, castLuxW, castLuxE, castLuxR } from './champions/lux.js';
import { createBrand, castBrandQ, castBrandW, castBrandE, castBrandR } from './champions/brand.js';
import { createVeigar, castVeigarQ, castVeigarW, castVeigarE, castVeigarR } from './champions/veigar.js';
import { createSoraka, castSorakaQ, castSorakaW, castSorakaE, castSorakaR } from './champions/soraka.js';
import { createLulu, castLuluQ, castLuluW, castLuluE, castLuluR } from './champions/lulu.js';
import { createNami, castNamiQ, castNamiW, castNamiE, castNamiR } from './champions/nami.js';
import { createEzreal, castEzrealQ, castEzrealW, castEzrealE, castEzrealR } from './champions/ezreal.js';
import { createCaitlyn, castCaitlynQ, castCaitlynW, castCaitlynE, castCaitlynR } from './champions/caitlyn.js';
import { createZed, castZedQ, castZedW, castZedE, castZedR } from './champions/zed.js';
import { createKatarina, castKatarinaQ, castKatarinaW, castKatarinaE, castKatarinaR } from './champions/katarina.js';
import { createYasuo, castYasuoQ, castYasuoW, castYasuoE, castYasuoR } from './champions/yasuo.js';
import {
  createRiven, castRivenQ, castRivenW, castRivenE, castRivenR, castRivenRWindSlash
} from './champions/riven.js';
import { createIrelia, castIreliaQ, castIreliaW, castIreliaE, castIreliaR } from './champions/irelia.js';
import { registerChampionFactory } from './champions/championFactory.js';

registerChampionFactory('ashe', createAshe);
registerChampionFactory('garen', createGaren);
registerChampionFactory('ryze', createRyze);
registerChampionFactory('annie', createAnnie);
registerChampionFactory('sivir', createSivir);
registerChampionFactory('darius', createDarius);
registerChampionFactory('sett', createSett);
registerChampionFactory('jax', createJax);
registerChampionFactory('lux', createLux);
registerChampionFactory('brand', createBrand);
registerChampionFactory('veigar', createVeigar);
registerChampionFactory('soraka', createSoraka);
registerChampionFactory('lulu', createLulu);
registerChampionFactory('nami', createNami);
registerChampionFactory('ezreal', createEzreal);
registerChampionFactory('caitlyn', createCaitlyn);
registerChampionFactory('zed', createZed);
registerChampionFactory('katarina', createKatarina);
registerChampionFactory('yasuo', createYasuo);
registerChampionFactory('riven', createRiven);
registerChampionFactory('irelia', createIrelia);

export { createAshe, castAsheW, castAsheR };
export { createGaren, castGarenQ, castGarenE, castGarenR };
export { createRyze, castRyzeQ, castRyzeW };
export { createAnnie, castAnnieQ, castAnnieW, castAnnieR };
export { createSivir, castSivirQ, castSivirE, castSivirR };
export { createDarius, castDariusQ, castDariusW, castDariusE, castDariusR };
export { createSett, castSettQ, castSettW, castSettE, castSettR };
export { createJax, castJaxQ, castJaxW, castJaxE, castJaxR };
export { createLux, castLuxQ, castLuxW, castLuxE, castLuxR };
export { createBrand, castBrandQ, castBrandW, castBrandE, castBrandR };
export { createVeigar, castVeigarQ, castVeigarW, castVeigarE, castVeigarR };
export { createSoraka, castSorakaQ, castSorakaW, castSorakaE, castSorakaR };
export { createLulu, castLuluQ, castLuluW, castLuluE, castLuluR };
export { createNami, castNamiQ, castNamiW, castNamiE, castNamiR };
export { createEzreal, castEzrealQ, castEzrealW, castEzrealE, castEzrealR };
export { createCaitlyn, castCaitlynQ, castCaitlynW, castCaitlynE, castCaitlynR };
export { createZed, castZedQ, castZedW, castZedE, castZedR };
export { createKatarina, castKatarinaQ, castKatarinaW, castKatarinaE, castKatarinaR };
export { createYasuo, castYasuoQ, castYasuoW, castYasuoE, castYasuoR };
export { createRiven, castRivenQ, castRivenW, castRivenE, castRivenR, castRivenRWindSlash };
export { createIrelia, castIreliaQ, castIreliaW, castIreliaE, castIreliaR };
export {
  registerChampionFactory,
  createChampion,
  hasChampionFactory,
  listChampionKeys
} from './champions/championFactory.js';
